import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { NewInputText } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import {
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import { errorAlert } from "../../../../../function/alert";
import { getSubCateogryWithCategoryId } from "../../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { amApi } from "../../../../../api/apiHelper";
import isEmpty from "../../../../../store/validation/is-Empty";


function ConfigurePosDetails({ handleShowTab, formik, ApiPosData,edit, ...props }) {
  const [iconsData, SetIconsData] = useState();
  const [next, setNext] = useState(false);
  const [cofiguredPosdata, setData] = useState();
  let history = useHistory();
  const location = useLocation();

  const pos_config_id = location?.state?.pos_id;

  const isPosIdExists = (cofiguredPosdata, posIdToCheck) => {
    if (pos_config_id && pos_config_id === posIdToCheck) {
      return false 
    }else{
      return cofiguredPosdata.some(
        (item) => item.pos_config_id?._id === posIdToCheck
      );
    }
  };

  const handleNext = () => {
    formik.validateForm().then(errors => {
      if (
        errors.name ||
        errors.company_address ||
        errors.website ||
        errors.email ||
        errors.point_of_contact ||
        errors.pos_config_id
      ) {
        errorAlert("Please fill in all mandatory fields with valid values.");
        setNext(true);
      } else if (isPosIdExists(cofiguredPosdata, formik.values.pos_config_id)) {
        errorAlert("Selected POS is already configured");
      } else {
        setNext(false);
        handleShowTab("2");
      }
    });
  };
  

  const onSuccess = (data) => {
    if (data) {
      SetIconsData(data);
    }
  };

  useEffect(() => {
    props.getSubCateogryWithCategoryId(onSuccess, "5fa2abe7a930bc32ce5790c7");
  }, []);

  const fetchData = async () => {
    try {
      const response = await amApi.get("admin/pos");
      if (response && response.data) {
        setData(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!isEmpty(ApiPosData) ) {
      formik.setFieldValue("name", ApiPosData?.name ? ApiPosData?.name : "");
      formik.setFieldValue(
        "company_address",
        ApiPosData?.company_address ? ApiPosData?.company_address : ""
      );
      formik.setFieldValue(
        "website",
        ApiPosData?.website ? ApiPosData?.website : ""
      );
      formik.setFieldValue("email", ApiPosData?.email ? ApiPosData?.email : "");
      formik.setFieldValue(
        "point_of_contact",
        ApiPosData?.point_of_contact ? ApiPosData?.point_of_contact : ""
      );
      formik.setFieldValue(
        "pos_config_id",
        ApiPosData?.pos_config_id ? ApiPosData?.pos_config_id : ""
      );
      formik.setFieldValue('runningStatus',ApiPosData?.runningStatus )
     // formik.validateForm();
    }
  }, [ApiPosData]);


console.log(formik.values.pos_config_id,"posId");
  return (
    <>
      <Form>
        <div className="col-6">
          <div className="col-12 p-0">
            <div className="f14-500 my-2">Name*</div>
            <NewInputText
              extraClass="m-0"
              displayLabel={true}
              controlId="name"
              variant="outlined"
              name="name"
              inputType="text"
              onChange={formik.handleChange}
              value={formik.values.name}
              required="required"
              errorTrue={formik.errors.name && next}
              errorText={formik.errors.name && next ? formik.errors.name : ""}
            />
          </div>
          <div className="col-12 p-0  my-3">
            <div className="f14-500 my-2">Select Pos*</div>
            <div>
              <FormControl
                variant="outlined"
                className="m-2"
                style={{ minWidth: "120px" }}
                fullWidth
                error={formik.errors.pos_config_id && next}
              >
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="pos_config_id"
                  value={formik.values.pos_config_id}
                  onChange={formik.handleChange}
                  disabled={edit}
                >
                  {iconsData?.map((icon, index) => {
                    return (
                      <MenuItem value={icon._id}>
                        <img src={icon?.icon} alt={icon?.title} width="20px" />
                        {icon.title}
                      </MenuItem>
                    );
                  })}
                </Select>
                <FormHelperText>
                  {formik.errors.pos_config_id && next
                    ? formik.errors.pos_config_id
                    : ""}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
          <div className="col-12 p-0">
            <div className="f14-500 my-2">Company Address*</div>
            <NewInputText
              extraClass="m-0"
              controlId="address"
              displayText={true}
              multiline={true}
              labelTextClass="text-area-lable"
              placeholder="company Address"
              rows="4"
              name="company_address"
              onChange={formik.handleChange}
              value={formik.values.company_address}
              required="required"
              errorTrue={formik.errors.company_address && next}
              onBlur={formik.handleBlur}
              errorText={
                formik.errors.company_address && next
                  ? formik.errors.company_address
                  : ""
              }
            />
          </div>
          <div className="col-12 p-0">
            <div className="f14-500 my-2">Website*</div>
            <NewInputText
              extraClass="m-0"
              displayLabel={true}
              controlId="name"
              variant="outlined"
              name="website"
              inputType="text"
              onChange={formik.handleChange}
              value={formik.values.website}
              required="required"
              errorTrue={formik.errors.website && next}
              errorText={
                formik.errors.website && next ? formik.errors.website : ""
              }
            />
          </div>
          <div className="col-12 p-0">
            <div className="f14-500 my-2">Email ID*</div>
            <NewInputText
              extraClass="m-0"
              displayLabel={true}
              controlId="name"
              variant="outlined"
              name="email"
              inputType="text"
              onChange={formik.handleChange}
              value={formik.values.email}
              required="required"
              errorTrue={formik.errors.email && next}
              errorText={formik.errors.email && next ? formik.errors.email : ""}
            />
          </div>
          <div className="col-12 p-0">
            <div className="f14-500 my-2">Point of contact no*</div>
            <NewInputText
              extraClass="m-0"
              displayLabel={true}
              controlId="point_of_contact"
              variant="outlined"
              placeHolder="website url"
              name="point_of_contact"
              inputType="number"
              onChange={formik.handleChange}
              value={formik.values.point_of_contact}
              required="required"
              errorTrue={formik.errors.point_of_contact && next}
              errorText={
                formik.errors.point_of_contact && next
                  ? formik.errors.point_of_contact
                  : ""
              }
            />
          </div>
          <div className="col-12 p-0  my-3">
            <div className="f14-500 my-2">Country code</div>
            <div>
              <FormControl
                variant="outlined"
                className="m-2"
                style={{ minWidth: "120px" }}
                fullWidth
              >
                <InputLabel id="demo-simple-select-label">
                  Country code
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={formik.values.countrycode}
                  label="country code"
                  onChange={formik.handleChange}
                  defaultValue={91}
                >
                  <MenuItem value={91}>+91</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="py-4 d-flex align-items-center">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5 btn150px"
              onClick={() => {
                history.push("/superadminposdashboard");
              }}
            >
              Back
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5 btn150px"
              //type="submit"
              onClick={(e) => handleNext()}
            >
              Next
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
}

ConfigurePosDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  getSubCateogryWithCategoryId: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getSubCateogryWithCategoryId,
})(ConfigurePosDetails);
